// extracted by mini-css-extract-plugin
export default {"breadcrumb":"Breadcrumb_breadcrumb__8rvmo","link":"Breadcrumb_link__VlW6z"};